import styled from 'styled-components'
import Button from 'react-bootstrap/Button';
import { Link as LinkR } from 'react-router-dom'

export const InfoContainer = styled.div`
  color: #fff;
  background: #010606;
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;

  @media screen and (max-width: 850px) {
    padding: 100px 0;
  }
`

export const InfoWrapper = styled.div`
  display: grid;
  z-index: 3;
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 0;
  align-items: center;
  position: absolute;
`

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: 850px) {
    flex-direction: column;
  }
`

export const TextWrapper = styled.div`
  max-width: 540px;
  padding: 0 0 60px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-right: 20px;

  @media screen and (max-width: 850px) {
    margin: 0 10px;
  }
`

export const TopLine = styled.p`
  color: #9df743;
  font-size: 16px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-bottom: 24px;
`

export const Heading = styled.h1`
  margin-bottom: 50px;
  font-size: 48px;
  line-height: 1.1;
  font-weight: 600;
  color: #fff;
  text-align: center;

  @media screen and (max-width: 850px) {
    font-size: 40px;
  }
`

export const Subtitle = styled.p`
  max-width: 440px;
  margin-bottom: 65px;
  font-size: 18px;
  line-height: 24px;
  color: ${({darkText}) => (darkText ? '#010606' : '#fff')};
`

export const BtnWrap = styled.div`
  display: flex;
  justify-content: flex-start;
`

export const ImgWrap = styled.div`
  max-width: 555px;
  height: 100%;
  margin-right: 40px;
  margin-left: 40px;

  @media screen and (max-width: 850px) {
    max-width: 400px;
  }
`

export const Img = styled.img`
  width: 100%;
  margin: 0 0 10px 0;
  padding-right: 0px;
`

export const MintSectionBg = styled.img`
  background-repeat: no-repeat;
  width: 100%;
  height: 860px;
  overflow: hidden;
  filter: brightness(30%);
`

export const Btn = styled(LinkR)`
  border-radius: 50px;
  background: #9df743;
  white-space: nowrap;
  /* padding: 14px 48px; */
  padding: 20px 60px;
  margin-top: 20px;
  color: #000;
  font-size: 24px;
  outline: none;
  cursor: pointer;
  display: flex;
  border: none;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #000;
    color: #9df743;
  }

  &:disabled {
    background: #aaaaaa;
    cursor: not-allowed;
    pointer-events: none;
  }

  @media screen and (max-width: 850px) {
    padding: 14px 48px;
    font-size: 18px;
  }
`

export const TextField = styled.input`
width: 200px;
`

export const TextFieldLabel = styled.label`
  font-size: 1.3rem;
  user-select: none;
`

export const MintUiWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const AmountButton = styled.button`
  border-radius: 50%;
  background: #9df743;
  white-space: nowrap;
  /* padding: 14px 48px; */
  /* padding: 20px 30px; */
  height: 50px;
  width: 50px;
  margin: 10px 30px;
  color: #000;
  font-size: 24px;
  outline: none;
  cursor: pointer;
  display: flex;
  border: none;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #000;
    color: #9df743;
  }
  
  &:disabled {
    background: #aaaaaa;
    cursor: not-allowed;
    pointer-events: none;
  }
`